module.exports = __webpack_public_path__ + "img/varied_lights.15e679a5.png";